import Styles from './AddMoreImages.module.scss'
import { Spinner } from 'common/Spinner/Spinner'
import { useUpdateImageDescriptions } from 'hooks/queries/brandKits/useUpdateImageDescriptions'
import { useBrandVisualKitSubscription } from 'hooks/useBrandVisualKitSubscription'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import React, { useEffect } from 'react'
import { useQueryClient } from 'react-query'

type Props = {
  brandKitId: number
  onImageDescriptionsUpdate: () => void
}

export const GeneratingImageDescriptions = ({ brandKitId, onImageDescriptionsUpdate }: Props): React.ReactElement => {
  const queryClient = useQueryClient()
  const workspaceId = useCurrentWorkspaceId()

  useBrandVisualKitSubscription({
    brandKitId,
    onImageDescriptionsUpdate: () => {
      queryClient.invalidateQueries(['workspaces', workspaceId, 'brandKits', 'detail', brandKitId])
      queryClient.invalidateQueries(['workspaces', workspaceId, 'brandProfile'])
      onImageDescriptionsUpdate()
    },
  })
  const { mutateAsync: updateImageDescriptions } = useUpdateImageDescriptions({ id: brandKitId })

  useEffect(() => {
    updateImageDescriptions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={Styles.generatingImageDescriptions}>
      <Spinner />
      <p>Preparing your brand kit to generate images for the first time. This may take a couple of minutes...</p>
    </div>
  )
}
